import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../@vex/layout/layout.module';
import { CustomLayoutComponent } from './custom-layout.component';
import { SidenavModule } from '../../@vex/layout/sidenav/sidenav.module';
import { ToolbarModule } from '../../@vex/layout/toolbar/toolbar.module';
import { FooterModule } from '../../@vex/layout/footer/footer.module';
import { ConfigPanelModule } from '../../@vex/components/config-panel/config-panel.module';
import { SidebarModule } from '../../@vex/components/sidebar/sidebar.module';
import { QuickpanelModule } from '../../@vex/layout/quickpanel/quickpanel.module';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import {MatMenuModule} from '@angular/material/menu';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {GlobalnavbarComponent} from '../pages/globalnavbar/globalnavbar.component';
import {GlobalserviciosComponent} from '../pages/globalservicios/globalservicios.component';
import {GlobalfooterComponent} from '../pages/globalfooter/globalfooter.component'
import {RegistrarAfiliadoComponent} from '../pages/registrar-afiliado/registrar-afiliado.component'
import { ComponenteprincipalComponent } from '../pages/componenteprincipal/componenteprincipal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ConfirmAfiliacionComponent } from '../pages/confirm-afiliacion/confirm-afiliacion.component';
import { CargaProspectosComponent } from '../pages/carga-prospectos/carga-prospectos.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmacionGenericaComponent } from '../pages/confirmaciongenerica/confirmaciongenerica.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ChartModule } from 'src/@vex/components/chart/chart.module';
import { WidgetLargeGoalChartModule } from '../../@vex/components/widgets/widget-large-goal-chart/widget-large-goal-chart.module';
import { WidgetQuickLineChartModule } from '../../@vex/components/widgets/widget-quick-line-chart/widget-quick-line-chart.module';
import { IconModule } from '@visurel/iconify-angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GestionAfiliadosComponent } from '../pages/gestion-afiliados/gestion-afiliados.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { GestionAfiliadosDetalleComponent } from '../pages/gestion-afiliados-detalle/gestion-afiliados-detalle.component';
import { GestionAfiliadosCarteraComponent } from '../pages/gestion-afiliados-cartera/gestion-afiliados-cartera.component';
import { DashboardVentasComponent } from '../pages/dashboard_ventas/dashboard_ventas.component';
import { DashboardAdministrativoComponent } from '../pages/dashboard_administrativo/dashboard_administrativo.component';
import { GestionAfiliadosEstadoComponent } from '../pages/gestion-afiliados-estado/gestion-afiliados-estado.component';
import { DashboardAdministradorComponent } from '../pages/dashboard_administrador/dashboard_administrador.component';
import { GestionAfiliadosConfirmacionComponent } from '../pages/gestion-afiliados-confirmacion/gestion-afiliados-confirmacion.component';
import { GlobalasesoresComponent } from '../pages/globalasesores/globalasesores.component';
import { GlobalinformaciongeneralComponent } from '../pages/globalinformaciongeneral/globalinformaciongeneral.component';
import { GlobalventasComponent } from '../pages/globalventas/globalventas.component';
import { GlobalafiliadosComponent } from '../pages/globalafiliados/globalafiliados.component';
import { GlobalafiliadosporfatolioComponent } from '../pages/globalafiliadosporfatolio/globalafiliadosporfatolio.component';
import { GlobalnuevosinactivosComponent } from '../pages/globalnuevosinactivos/globalnuevosinactivos.component';
import { GlobalciudadesComponent } from '../pages/globalciudades/globalciudades.component';
import { GlobalresumenafiliadosComponent } from '../pages/globalresumenafiliados/globalresumenafiliados.component';
import { GlobalresumenasistenciasComponent } from '../pages/globalresumenasistencias/globalresumenasistencias.component';
import { SeleccionAliadoCanalComponent } from '../pages/seleccionaliadocanal/seleccionaliadocanal.component';
import { MaestrosSectorComponent } from '../pages/maestrossector/maestros-sector.component';
import { MaestrosSectorEditarComponent } from '../pages/maestrossector-editar/maestros-sector-editar.component';
import { MaestrosRolesDominioEditarComponent } from '../pages/maestrosrolesdominio-editar/maestros-rolesdominio-editar.component';
import { MaestrosRolesDominioComponent } from '../pages/maestrosrolesdominio/maestros-rolesdominio.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaestrosRolesComponent } from '../pages/maestrosroles/maestros-roles.component';
import { MaestrosRolesEditarComponent } from '../pages/maestrosroles-editar/maestros-roles-editar.component';
import { MaestrosAliadosComponent } from '../pages/maestrosaliados/maestros-aliados.component';
import { MaestrosAliadosEditarComponent } from '../pages/maestrosaliados-editar/maestros-aliados-editar.component';
import { MaestrosDashboardComponent } from '../pages/maestrosdashboard/maestros-dashboard.component';
import { MaestrosDashboardEditarComponent } from 'src/app/pages/maestrosdashboard-editar/maestros-dashboard-editar.component';
import { MaestrosUsuariosComponent } from '../pages/maestrosusuarios/maestros-usuarios.component';
import { MaestrosUsuariosEditarComponent } from '../pages/maestrosusuarios-editar/maestros-usuarios-editar.component';
import { MaestrosGruposComponent } from '../pages/maestrosgrupos/maestros-grupos.component';
import { MaestrosGruposEditarComponent } from '../pages/maestrosgrupos-editar/maestros-grupos-editar.component';
import { MaestrosMatrizAccesoComponent } from '../pages/maestrosmatrizacceso/maestros-matrizacceso.component';
import { MaestrosProvinciasComponent } from '../pages/maestrosprovincias/maestros-provincias.component';
import { MaestrosProvinciasEditarComponent } from '../pages/maestrosprovincias-editar/maestros-provincias-editar.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { GenerarConsultasComponent } from '../pages/generarconsultas/generarconsultas.component';
import { MaestrosConsultasComponent } from '../pages/maestrosconsultas/maestros-consultas.component';
import { MaestrosConsultasEditarComponent } from '../pages/maestrosconsultas-editar/maestros-consultas-editar.component';
import { GenerarConsultasEjecutarComponent } from '../pages/generarconsultas-ejecutar/generarconsultas-ejecutar.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import {MatTreeModule} from '@angular/material/tree';
import { CargandoComponent } from '../pages/cargando/cargando.component';
import { MaestrosMenuComponent } from '../pages/maestrosmenu/maestros-menu.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AdicionarItemsListaComponent } from '../pages/adicionar-items-lista/adicionar-items-lista.component';
import { MatListModule } from '@angular/material/list';
import { SubirArchivosUsuarioComponent } from '../pages/subirarchivosusuario/subirarchivosusuario.component';
import { MaestrosCargasArchivosComponent } from '../pages/maestroscargasarchivos/maestros-cargasarchivos.component';
import { MaestrosCargasArchivosEditarComponent } from '../pages/maestroscargasarchivos-editar/maestros-cargasarchivos-editar.component';
import { DndDirective } from '../directives/dnd.directive';
import { DashboardAliadoComponent } from '../pages/dashboard_aliado/dashboard_aliado.component';
import { FechaPipe } from '../pipes/fechapipe';
import { NumeroPipe } from '../pipes/numeropipe';
import { AdicionarItemsListaAdicionalesComponent } from '../pages/adicionar-items-lista-adicionales/adicionar-items-lista-adicionales.component';
import { MaestrosCargaApiClientesAseguradosComponent } from '../pages/maestroscargasapiclientesasegurados/maestros-cargaapiclientesasegurados.component';
import { MaestrosCargaApiClientesAseguradosEditarComponent } from '../pages/maestroscargasapiclientesasegurados-editar/maestros-cargaapiclientesasegurados-editar.component';
import { ModificarPlantillaComponent } from '../pages/modificar-plantilla/modificar-plantilla.component';
import { RecaudosComponent } from '../pages/recaudos/recaudos.component';
import { SeleccionarArchivoComponent } from '../pages/seleccionararchivo/seleccionararchivo.component';
import { MaestrosMatrizAccesoGruposComponent } from '../pages/maestrosmatrizaccesogrupos/maestros-matrizaccesogrupos.component';
import { MaestrosProductosComponent } from '../pages/maestrosproductos/maestros-productos.component';
import { MaestrosProductosEditarComponent } from '../pages/maestrosproductos-editar/maestros-productos-editar.component';
import { MenuConfiguracionComponent } from '../pages/menuconfiguracion/menu-configuracion.component';
import { FirmaElectronicaComponent } from '../pages/firmaelectronica/firma-electronica.component';
import { FirmaElectronicaGenerarComponent } from '../pages/firmaelectronica-generar/firma-electronica-generar.component';
import { GlobalventasVendedorComponent } from '../pages/globalventasvendedor/globalventasvendedor.component';
import { OperacionesReembolsoComponent } from '../pages/operaciones-reembolso/operaciones-reembolso.component';
import { OperacionesReembolsoActualizarComponent } from '../pages/operaciones-reembolso-actualizar/operaciones-reembolso-actualizar.component';
import { OperacionesReembolsoUbicacionComponent } from '../pages/operaciones-reembolso-ubicacion/operaciones-reembolso-ubicacion.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ExpedientesComponent } from '../pages/expedientes/expedientes.component';
import { ExpedientesDetalleComponent } from '../pages/expedientes-detalle/expedientes-detalle.component';
import { DashboardExpedientesComponent } from '../pages/dashboard_expedientes/dashboard_expedientes.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MaestrosMarcasComponent } from '../pages/maestrosmarcas/maestros-marcas.component';
import { MaestrosMarcasEditarComponent } from '../pages/maestrosmarcas-editar/maestros-marcas-editar.component';
import { MaestrosConfiguracionComercializacionComponent } from '../pages/maestrosconfiguracioncomercializacion/maestros-configuracioncomercializacion.component';
import { MaestrosConfiguracionComercializacionEditarComponent } from '../pages/maestrosconfiguracioncomercializacion-editar/maestros-configuracioncomercializacion-editar.component';


@NgModule({
  declarations: [CustomLayoutComponent, GlobalnavbarComponent, 
    GlobalserviciosComponent,
    GlobalfooterComponent,
    ComponenteprincipalComponent,
    DashboardVentasComponent,
    DashboardAdministrativoComponent,
    DashboardAdministradorComponent,
    DashboardAliadoComponent,
    DashboardExpedientesComponent,
    RegistrarAfiliadoComponent,
    ConfirmAfiliacionComponent,
    CargaProspectosComponent,
    ConfirmacionGenericaComponent,
    GestionAfiliadosComponent,
    GestionAfiliadosDetalleComponent,
    GestionAfiliadosCarteraComponent,
    GestionAfiliadosEstadoComponent,
    GestionAfiliadosConfirmacionComponent,
    GlobalasesoresComponent,
    GlobalinformaciongeneralComponent,
    GlobalventasComponent,
    GlobalventasVendedorComponent,
    GlobalafiliadosComponent,
    GlobalafiliadosporfatolioComponent,
    GlobalnuevosinactivosComponent,
    GlobalciudadesComponent,
    GlobalresumenafiliadosComponent,
    GlobalresumenasistenciasComponent,
    SeleccionAliadoCanalComponent,
    MaestrosSectorComponent,
    MaestrosSectorEditarComponent,
    MaestrosRolesDominioComponent,
    MaestrosRolesDominioEditarComponent,
    MaestrosRolesComponent,
    MaestrosRolesEditarComponent,
    MaestrosAliadosComponent,
    MaestrosAliadosEditarComponent,
    MaestrosDashboardComponent,
    MaestrosDashboardEditarComponent,
    MaestrosUsuariosComponent,
    MaestrosUsuariosEditarComponent,
    MaestrosGruposComponent,
    MaestrosGruposEditarComponent,
    MaestrosMatrizAccesoComponent,
    MaestrosMatrizAccesoGruposComponent,
    MaestrosProvinciasComponent,
    MaestrosProvinciasEditarComponent,
    GenerarConsultasComponent,
    MaestrosConsultasComponent,
    GenerarConsultasEjecutarComponent,
    MaestrosConsultasEditarComponent,
    CargandoComponent,
    MaestrosMenuComponent,
    AdicionarItemsListaComponent,
    AdicionarItemsListaAdicionalesComponent,
    SubirArchivosUsuarioComponent,
    MaestrosCargasArchivosComponent,
    MaestrosCargasArchivosEditarComponent,
    MaestrosCargaApiClientesAseguradosComponent,
    MaestrosCargaApiClientesAseguradosEditarComponent,
    MaestrosProductosComponent,
    MaestrosProductosEditarComponent,
    FirmaElectronicaComponent,
    FirmaElectronicaGenerarComponent,
    ExpedientesComponent,
    ExpedientesDetalleComponent,
    OperacionesReembolsoComponent,
    OperacionesReembolsoActualizarComponent,
    OperacionesReembolsoUbicacionComponent,
    MenuConfiguracionComponent,
    ModificarPlantillaComponent,
    RecaudosComponent,
    SeleccionarArchivoComponent,
    DndDirective,
    FechaPipe,
    NumeroPipe,
    MaestrosMarcasComponent,
    MaestrosMarcasEditarComponent,
    MaestrosConfiguracionComercializacionComponent,
    MaestrosConfiguracionComercializacionEditarComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SidenavModule,
    ToolbarModule,
    FooterModule,
    ConfigPanelModule,
    SidebarModule,
    QuickpanelModule,
    MatSidenavModule,
    MatIconModule,
    MatCardModule,
    IvyCarouselModule,
    MatMenuModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogModule,
    MatProgressBarModule,
    MatCardModule,
    WidgetLargeGoalChartModule,
    WidgetQuickLineChartModule,
    ChartModule,
    IconModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatTableModule,
    MatIconModule,
    MatCardModule,
    MatCheckboxModule,
    NgApexchartsModule,
    MatTableExporterModule,
    MatTreeModule,
    MatTabsModule,
    MatListModule,
    GoogleMapsModule,
    GooglePlaceModule,
    MatStepperModule,
    MatButtonModule,
    MatAutocompleteModule
  ],
  exports: [CustomLayoutComponent, GlobalnavbarComponent, 
    GlobalserviciosComponent,
    GlobalfooterComponent,
    ComponenteprincipalComponent,
    DashboardVentasComponent,
    DashboardAdministrativoComponent,
    DashboardAdministradorComponent,
    DashboardAliadoComponent,
    RegistrarAfiliadoComponent,
    ConfirmAfiliacionComponent,
    CargaProspectosComponent,
    ConfirmacionGenericaComponent,
    GestionAfiliadosComponent,
    GestionAfiliadosDetalleComponent,
    GestionAfiliadosCarteraComponent,
    GestionAfiliadosEstadoComponent,
    GestionAfiliadosConfirmacionComponent,
    GlobalasesoresComponent,
    GlobalinformaciongeneralComponent,
    GlobalventasComponent,
    GlobalafiliadosComponent,
    GlobalafiliadosporfatolioComponent,
    GlobalnuevosinactivosComponent,
    GlobalciudadesComponent,
    GlobalresumenafiliadosComponent,
    GlobalresumenasistenciasComponent,
    SeleccionAliadoCanalComponent,
    MaestrosSectorComponent,
    MaestrosSectorEditarComponent,
    MaestrosRolesDominioComponent,
    MaestrosRolesDominioEditarComponent,
    MaestrosRolesComponent,
    MaestrosRolesEditarComponent,
    MaestrosAliadosComponent,
    MaestrosAliadosEditarComponent,
    MaestrosDashboardComponent,
    MaestrosDashboardEditarComponent,
    MaestrosUsuariosComponent,
    MaestrosUsuariosEditarComponent,
    MaestrosGruposComponent,
    MaestrosGruposEditarComponent,
    MaestrosMatrizAccesoComponent,
    MaestrosProvinciasComponent,
    MaestrosProvinciasEditarComponent,
    GenerarConsultasComponent,
    MaestrosConsultasComponent,
    GenerarConsultasEjecutarComponent,
    MaestrosConsultasEditarComponent,
    CargandoComponent,
    MaestrosMenuComponent,
    AdicionarItemsListaComponent,
    SubirArchivosUsuarioComponent,
    MaestrosCargasArchivosComponent,
    MaestrosCargasArchivosEditarComponent,
    MaestrosCargaApiClientesAseguradosComponent,
    MaestrosCargaApiClientesAseguradosEditarComponent,
    MaestrosProductosComponent,
    MaestrosProductosEditarComponent,
    FirmaElectronicaComponent,
    FirmaElectronicaGenerarComponent,
    ExpedientesComponent,
    ExpedientesDetalleComponent,
    OperacionesReembolsoComponent,
    OperacionesReembolsoActualizarComponent,
    OperacionesReembolsoUbicacionComponent,
    MenuConfiguracionComponent,
    RecaudosComponent,
    SeleccionarArchivoComponent,
    ModificarPlantillaComponent,
    MaestrosMarcasComponent,
    MaestrosMarcasEditarComponent,
    MaestrosConfiguracionComercializacionComponent,
    MaestrosConfiguracionComercializacionEditarComponent
  ],
  providers:[],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomLayoutModule {
}
